import React, { useEffect, useState, useRef } from 'react';
import { Html5Qrcode, Html5QrcodeSupportedFormats } from 'html5-qrcode';
import axios from 'axios';

const AdminScan = () => {
  const [isScanning, setIsScanning] = useState(false);
  const [result, setResult] = useState(null); 
  const [msg, setMsg] = useState('');
  
  // Input Form
  const [manualCode, setManualCode] = useState('');
  const [manualName, setManualName] = useState('');

  const scannerRef = useRef(null); 

  useEffect(() => {
    if (isScanning && result === null) {
        const timer = setTimeout(() => { startCamera(); }, 100);
        return () => clearTimeout(timer);
    }
  }, [isScanning, result]);

  const startCamera = () => {
    if (scannerRef.current) return;
    const html5QrCode = new Html5Qrcode("reader");
    scannerRef.current = html5QrCode;
    const config = { 
        fps: 20, qrbox: { width: 300, height: 150 }, 
        aspectRatio: 1.0,
        formatsToSupport: [ Html5QrcodeSupportedFormats.CODE_128, Html5QrcodeSupportedFormats.EAN_13, Html5QrcodeSupportedFormats.QR_CODE ],
        experimentalFeatures: { useBarCodeDetectorIfSupported: true }
    };
    html5QrCode.start(
      { facingMode: "environment" }, config, 
      (decodedText) => {
        if (!/^[0-9]+$/.test(decodedText)) return; 
        stopCamera();
        handleCheckIn(decodedText);
      },
      (errorMessage) => { }
    ).catch(err => {
      html5QrCode.start({ facingMode: "user" }, config, (t)=>{stopCamera();handleCheckIn(t);}, ()=>{}).catch(e=>{
          setMsg('âŒ Lá»—i Camera. F5 láº¡i!'); setIsScanning(false);
      });
    });
  };

  const stopCamera = () => {
    if (scannerRef.current) {
        scannerRef.current.stop().then(() => {
            scannerRef.current.clear();
            scannerRef.current = null;
            setIsScanning(false);
        }).catch(err => { setIsScanning(false); scannerRef.current = null; });
    } else { setIsScanning(false); }
  };

  const handleCheckIn = async (code) => {
    if (!code) return;
    if (!/^[0-9]+$/.test(code)) { setResult('error'); setMsg('âŒ MÃ£ khÃ´ng há»£p lá»‡'); return; }

    setMsg('â³ Äang xá»­ lÃ½: ' + code);
    try {
      // Gá»­i cáº£ tÃªn náº¿u cÃ³
      const payload = { employee_code: code.trim() };
      if (manualName) payload.full_name = manualName.trim();

      const res = await axios.post('/api/checkin', payload);
      setResult('success');
      setMsg('âœ… ' + res.data.message);
      setManualCode('');
      setManualName(''); // Reset name
    } catch (err) {
      setResult('error');
      setMsg('âŒ ' + (err.response?.data?.message || 'Lá»—i'));
    }
  };

  return (
    <div style={{ textAlign: 'center', padding: 20, maxWidth: 600, margin: '0 auto', fontFamily: 'Arial' }}>
      <h2>Admin Check-in</h2>
      {isScanning && (
        <div style={{ marginBottom: 20 }}>
            <p style={{fontSize: 12, color: '#ccc'}}>Chá»‰ nháº­n mÃ£ Sá» (Code 128 / QR)</p>
            <div id="reader" style={{ width: '100%', border: '2px solid #333', minHeight: '300px', background: '#000' }}></div>
            <button onClick={stopCamera} style={{marginTop: 15, padding: '10px 20px', background: '#dc3545', color: 'white', border: 'none', borderRadius: 5}}>Há»§y</button>
        </div>
      )}
      {!isScanning && result === null && (
        <div style={{ padding: 40, background: '#e9ecef', borderRadius: 10, marginBottom: 20 }}>
            <p>Sáºµn sÃ ng quÃ©t</p>
            <button onClick={() => {setResult(null); setMsg(''); setIsScanning(true);}} style={{
                padding: '20px 40px', fontSize: '20px', fontWeight: 'bold',
                background: '#007bff', color: 'white', border: 'none', borderRadius: '8px', width: '100%',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }}>ðŸ“· Báº®T Äáº¦U</button>
        </div>
      )}
      {result !== null && (
        <div style={{ padding: 30, background: result === 'success' ? '#d4edda' : '#f8d7da', borderRadius: 10, marginBottom: 20 }}>
            <h2 style={{ color: result === 'success' ? '#155724' : '#721c24' }}>{msg}</h2>
            <button onClick={() => {setResult(null); setIsScanning(true);}} style={{
                marginTop: 20, padding: '15px 30px', fontSize: '18px', fontWeight: 'bold',
                background: '#28a745', color: 'white', border: 'none', borderRadius: '5px', width: '100%'
            }}>TIáº¾P Tá»¤C âž¡ï¸</button>
             <div style={{marginTop: 15}}>
                <button onClick={() => {setResult(null); setIsScanning(false);}} style={{background:'transparent', border: 'none', textDecoration: 'underline'}}>Vá» mÃ n hÃ¬nh chÃ­nh</button>
            </div>
        </div>
      )}
      <hr style={{margin: '30px 0', opacity: 0.3}} />
      <div style={{ background: '#f8f9fa', padding: 15, borderRadius: 5, textAlign: 'left' }}>
        <h4>Nháº­p tay Check-in</h4>
        <div style={{marginBottom: 10}}>
             <label style={{display:'block', fontSize:12, color:'#666'}}>MÃ£ nhÃ¢n viÃªn (*)</label>
             <input value={manualCode} onChange={(e) => setManualCode(e.target.value)} placeholder="Nháº­p mÃ£ sá»‘..." style={{width: '100%', padding: 10, boxSizing: 'border-box'}} />
        </div>
        <div style={{marginBottom: 10}}>
             <label style={{display:'block', fontSize:12, color:'#666'}}>TÃªn nhÃ¢n viÃªn (TÃ¹y chá»n)</label>
             <input value={manualName} onChange={(e) => setManualName(e.target.value)} placeholder="Nháº­p há» tÃªn..." style={{width: '100%', padding: 10, boxSizing: 'border-box'}} />
        </div>
        <button onClick={() => handleCheckIn(manualCode)} style={{width: '100%', padding: '12px', background: '#6c757d', color: 'white', border: 'none', borderRadius: 5, fontWeight: 'bold'}}>Gá»¬I CHECK-IN</button>
      </div>
    </div>
  );
};
export default AdminScan;
